import React from "react";
import { FormField, CardSection } from "../../Common/FormComponents";

const STATUS_OPTIONS_BY_TYPE = {
  one_time_rental: [
    { value: "available",     label: "Available" },
    { value: "pending",       label: "Pending" },
    { value: "rented",        label: "Rented" },
    { value: "withdrawn",     label: "Withdrawn" },
  ],
  property_management: [
    { value: "active",        label: "Active" },
    { value: "inactive",      label: "Inactive" },
    { value: "terminated",    label: "Terminated" },
  ],
  sale: [
    { value: "available",     label: "Available" },
    { value: "under_contract", label: "Under Contract" },
    { value: "sold",          label: "Sold" },
    { value: "withdrawn",     label: "Withdrawn" },
  ],
};

const UnitBasicInfoSection = ({ formData, handleInputChange }) => {
  const statusOptions = STATUS_OPTIONS_BY_TYPE[formData.type] || STATUS_OPTIONS_BY_TYPE.one_time_rental;

  return (
  <CardSection title="Basic Information">
    <div style={{ display: "grid", gap: "0.75rem" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "0.75rem" }}>
        <FormField
          label="Unit Number"
          name="unitNumber"
          value={formData.unitNumber}
          onChange={handleInputChange}
          required
          placeholder="e.g., 101"
        />
        <FormField
          label="Floor"
          name="floor"
          type="number"
          value={formData.floor}
          onChange={handleInputChange}
          placeholder="e.g., 1"
        />
        <FormField
          label="Type"
          name="type"
          type="select"
          value={formData.type}
          onChange={handleInputChange}
          required
          options={[
            { value: "one_time_rental", label: "One Time Rental" },
            { value: "property_management", label: "Property Management" },
            { value: "sale", label: "Sale" },
          ]}
        />
        <FormField
          label="Status"
          name="status"
          type="select"
          value={formData.status}
          onChange={handleInputChange}
          required
          options={statusOptions}
        />
      </div>
      <FormField
        label="Unit Title"
        name="title"
        value={formData.title}
        onChange={handleInputChange}
        required
        placeholder="Enter unit title"
      />
      <FormField
        label="Description"
        name="description"
        as="textarea"
        rows={3}
        value={formData.description}
        onChange={handleInputChange}
        placeholder="Enter unit description..."
        className="mb-0"
      />
    </div>
  </CardSection>
  );
};

export default UnitBasicInfoSection;
